import {Component, Output, Input, EventEmitter} from '@angular/core';
import {NgbActiveOffcanvas} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-confirmation-canvas',
  templateUrl: './confirmation-canvas.component.html',
  styleUrl: './confirmation-canvas.component.scss'
})
export class ConfirmationCanvasComponent {

  @Input() title: string = ""
  @Input() text: string = ""
  @Output() onConfirm = new EventEmitter<void>();

  constructor(public activeOffcanvas: NgbActiveOffcanvas) {
  }

  dismiss(reason?: string) {
    this.activeOffcanvas.dismiss(reason);
  }

  confirm() {
    this.onConfirm.emit()
  }

  cancel() {
    this.activeOffcanvas.dismiss();
  }


}
